import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Global error handler
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

// Ensure Supabase client is properly initialized before rendering
const initializeApp = async () => {
  try {
    const rootElement = document.getElementById("root");
    
    if (!rootElement) {
      throw new Error('Root element not found');
    }
    
    const root = createRoot(rootElement);
    root.render(<App />);
  } catch (error) {
    console.error('Failed to initialize app:', error);
    
    // Fallback error display
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="
          display: flex; 
          align-items: center; 
          justify-content: center; 
          min-height: 100vh; 
          background: #f8fafc; 
          font-family: system-ui, -apple-system, sans-serif;
          padding: 20px;
        ">
          <div style="
            background: white; 
            padding: 40px; 
            border-radius: 8px; 
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
            text-align: center;
            max-width: 400px;
          ">
            <h1 style="color: #dc2626; margin-bottom: 16px;">Erro ao Carregar</h1>
            <p style="color: #6b7280; margin-bottom: 24px;">
              Ocorreu um erro ao carregar a aplicação. Tente recarregar a página.
            </p>
            <button 
              onclick="window.location.reload()" 
              style="
                background: #3b82f6; 
                color: white; 
                border: none; 
                padding: 12px 24px; 
                border-radius: 6px; 
                cursor: pointer;
                font-weight: 500;
              "
            >
              Recarregar Página
            </button>
          </div>
        </div>
      `;
    }
  }
};

initializeApp();